import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Box, Label, formatDate } from "Application";
import { CellContext, ColumnDef } from "@tanstack/react-table";
import { DataTable } from "Components/Primitives/DataTable";
import { CancelSVG } from "Assets/Icons/Cancel";
import { DownloadIcon } from "Assets/Icons/DownloadIcon";
import { isNullOrUndefined } from "@shoothill/core";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { SessionDocument } from "Shared/Models/StudentSessionReport";
import { DocumentsTableWrapper } from "./SessionReport.styles";

interface IProps {
    viewModel: IStudentSessionReportViewModel;
    data: SessionDocument[];
}

export const SessionReportDocumentsTable: React.FC<IProps> = observer(({ viewModel, data }) => {
    const defaultColumns = useMemo<ColumnDef<any>[]>(
        () => [
            {
                header: " ",
                columns: [
                    {
                        accessorKey: "fileName",
                        header: () => <Label fontStyle="h4">FILE NAME</Label>,
                        cell: (props: CellContext<any, any>) => (
                            <Box
                                flexBox
                                alignItems={"center"}
                                gap={"10px"}
                                style={{ cursor: "pointer" }}
                                onClick={() => viewModel.downloadResourceDocumentCommand.execute(props.row.original.id!)}
                            >
                                <DownloadIcon />
                                <Box>
                                    <Label>{props.row.original.fileName}</Label>
                                    <Label style={{ font: "normal normal normal 10px/16px Open Sans", letterSpacing: "-0.1px", color: "#D4D2D7" }}>
                                        {props.row.original.fileSize}kb
                                    </Label>
                                </Box>
                            </Box>
                        ),
                    },
                    {
                        accessorKey: "documentCategoryName",
                        header: () => <Label fontStyle="h4">CATEGORY</Label>,
                        cell: (props: CellContext<any, any>) => (
                            <Box flexBox>
                                <Label>{props.row.original.documentCategoryName}</Label>
                            </Box>
                        ),
                    },
                    {
                        accessorKey: "lastAction",
                        header: () => <Label fontStyle="h4">ADDED BY</Label>,
                        cell: (props: CellContext<any, any>) => (
                            <Box flexBox flexDirection={"column"} width={"100%"} textAlign={"end"}>
                                <Label>{!isNullOrUndefined(props.row.original.createdDate) ? formatDate(props.row.original.createdDate!) : ""}</Label>
                                <Label>
                                    {props.row.original.createdByFirstName} {props.row.original.createdByLastName}
                                </Label>
                            </Box>
                        ),
                    },
                    {
                        accessorKey: "actions",
                        header: () => <Label fontStyle="h4"></Label>,
                        enableSorting: false,
                        cell: (props: CellContext<any, any>) => (
                            <Box
                                flexBox
                                justifyContent={"center"}
                                alignContent={"center"}
                                width={"100%"}
                                style={{ cursor: "pointer" }}
                                onClick={() => viewModel.removeStudentDocumentsCommand.execute(props.row.original)}
                            >
                                <CancelSVG />
                            </Box>
                        ),
                    },
                ],
            },
        ],
        [viewModel],
    );

    return (
        <DocumentsTableWrapper>
            <DataTable data={data} columns={defaultColumns} showFilters={false} showSearchBox={false} />
        </DocumentsTableWrapper>
    );
});
